import { Spin } from "antd"
import styles from './LoadingPage.module.css';
const LoadingPage = ()=>{
    return <div className={styles.LoadingPage}>
        <Spin size="large" />
        <h3 className={styles.Text}>درحال بارگزاری ...</h3>
    </div>
}
export default LoadingPage;